<!--角色切换tab-->
<template>
  <div class="tabs-wrap">
    <ul>
      <li
        v-for="(user, index) in totalAccountList"
        :key="index"
        :title="user.corpName || user.name || user.username"
        @click="changeAccount(user)"
        :class="$store.getters.currentAuthUser &&
          $store.getters.currentAuthUser.corpUserId === user.corpUserId &&
          ($route.path === '/ywtSystem' && user.systemType ||  $route.path !== '/ywtSystem' && !user.systemType)
          ? 'current'
          : ''"
        >
        <img
          :src="isCurrent(user) ? '/images/icon/dingIcon-act.png' : '/images/icon/dingIcon.png'"
          alt="钉钉"
          width="20px"
          v-if="user.userStemFrom === -16 && !isInDingTalk"
        />
        <template  v-if="user.systemType === 'ywt'">
          <img style="max-height: 25px" src="../../static/images/ywt_logo.png" alt="">
          <span>（{{(user.corpName || user.name || user.username).substring(0, 5)}}）</span>
        </template>
        <span v-else>{{ user.corpName || user.name || user.username }}</span>
      </li>
    </ul>
    <div class="pad-bom"></div>
    <goto-auth :authDialog.sync="authDialog"></goto-auth>
  </div>
</template>

<script>
import {
  loginOrRefresh,
  setCurrentUser
} from "@/assets/js/http-serve/corp/common";
import { isInDingTalk } from "../../assets/js/utils/ding-env";
export default {
  name: "index",
  props: {
    tabs: {
      type: Object,
      default () {
        return { haveBind: false, binds: [] };
      }
      // haveBind 表示是否要用 binds中的数据
    },
    ywtTab: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return { 
      isInDingTalk,
      authDialog: false,
    };
  },
  computed: {
    currentAuthUser() {
      return this.$store.getters.currentAuthUser;
    },
    totalAccountList () {
      let arr = [this.$store.getters.allAuthUser.accountInfoVO],
        bindCorpUsers = this.$store.getters.allAuthUser.bindCorpUsers;
      if (isInDingTalk) {
        // 钉钉环境
        const info = JSON.parse(sessionStorage.getItem("dingloginInfo"));
        if (isInDingTalk) {
          bindCorpUsers = bindCorpUsers.filter(user => {
            return info.jzqCorpId === user.corpId;
          });
        }
      }
      // bind中判断 haveBind true 加入的企业用传递来的数据
      if (this.tabs.haveBind) {
        arr = this.tabs.binds.concat(arr);
      } else {
        arr = bindCorpUsers.concat(arr);
      }
      let arr1 = arr.flatMap((item, index)=> {
        //前面是是否开通了ywt， this.ywtTab 是指是否需要显示有ywttab的 role-tab组件， item.ywtIsBind是否开通了ywt权限
        return (item.corpIsMerchant === 1 || item.merchantFlag === 1) && this.ywtTab && item.ywtIsBind ? [item, { systemName: '业务定制系统', systemType: 'ywt', ...item}] : item;
      })
      return arr1;
    }
  },
  mounted() {
  },
  methods: {
    isCurrent(user){
      return this.$store.getters.currentAuthUser &&
          this.$store.getters.currentAuthUser.corpUserId === user.corpUserId
    },
    changeAccount (user) {
      if (user.corpName && this.$store.getters.authUser.identityAuth === -1) {
        this.authDialog = true;
        return;
      }
      if (this.isCurrent(user) && user.systemType === 'ywt' && this.$route.path === '/ywtSystem') {
        return false;
      }
      // this.$store.commit('SET_CONSOLE_TOKEN', null);
      setCurrentUser(user).finally(() => {
        if (user.systemType === 'ywt') {
          if (this.$route.path !== '/ywtSystem') {
            this.$router.push({
              path: '/ywtSystem',
              query: {
                ...this.$route.query,
                ywtLayoutStyle: 1,
                work: 1,
              },
            });
          }
        } else if (this.$route.path === '/ywtSystem') {
          this.$router.push({
            path: user.corpUserId ? '/corp/signInfo/signList' : '/signInfo/signList',
            query: this.$route.query,
          })
        } else if (
          this.$store.getters.currentAuthUser &&
          this.$store.getters.currentAuthUser.corpUserId &&
          (this.$route.path === "/signInfo/preservation" ||
            this.$route.path === "/signInfo/baoguanhan")
        ) {
          const path = '/corp/signInfo/signList';
          if (this.$route.path !== path) {
            this.$router.push({
              path,
              query: { signStatus: 2 }
            });
          }
        }
        this.$emit('change')
      });
    }
  },
};
</script>

<style lang="less" scoped>
@import url('../../assets/style/cssVariable.less');
.tabs-wrap {
  ul,
  li {
    list-style: none;
  }
  ul {
    display: flex;
    justify-content: flex-start;
    align-items: flex-end;
  }
  li {
    cursor: pointer;
    box-sizing: border-box;
    text-align: center;
    width: 230px;
    height: 30px;
    line-height: 30px;
    font-size: 14px;
    font-family: Source Han Sans SC;
    font-weight: 400;
    color: rgba(41, 2, 2, 0.95);
    padding: 0 23px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    border-radius: 8px 8px 0px 0px;
    background: @ebq-grey-white2;
    margin-right: 5px;
    &.current {
      font-size: 14px;
      font-family: Source Han Sans SC;
      font-weight: bold;
      color: @ebq-white;
      height: 40px;
      line-height: 40px;
      background: @ebq-red;
    }
    &:last-child {
      margin-right: 0;
    }
  }
  .pad-bom {
    height: 10px;
    /*background: #ffffff;*/
    background: linear-gradient(180deg, #ffffff, #ffffff, transparent);
    /*box-shadow:0px 0px 10px rgba(0, 0, 0, .04) inset;*/
    border-radius: 2px 2px 0 0;
  }
}
</style>



// WEBPACK FOOTER //
// components/role-tab/index.vue